<template>
  <b-overlay :show="loading" class="animated">
    <modal-trash-basket
      v-if="show_modal"
      :entity_type="entity_type"
      :trash="trash"
      @onUpdate="onUpdate"
    />
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="instrument-jig-server-table"
      class="w-100"
    >
      <span slot="instrument.name" slot-scope="{ row }">
        <existence-gate :entity="row" :levels="['instrument']" :field="'name'">
          <template #existing-content>
            <router-link
              :to="`/instrument/${getData(row, {
                levels: ['instrument'],
                field: 'id',
              })}`"
            >
              {{ getData(row, { levels: ["instrument"], field: "name" }) }}
            </router-link>
          </template>
        </existence-gate>
      </span>
      <template slot="actions" slot-scope="{ row }">
        <a
          v-show="checkPermission('edit instrument jig')"
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/instrument/${instrument_id}/instrument-jig/${row.jig_id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <template v-if="checkPermission('delete instrument jig')">
          <a
            v-if="isDeleted(row.id)"
            class="btn btn-success px-1 py-0 text-white mr-1"
            @click="restoreFromTrash(row.id)"
          >
            <i class="fa fa-refresh" />
          </a>
          <a
            v-else
            class="btn btn-danger px-1 py-0 text-white mr-1"
            @click="putToTrash(row)"
          >
            <i class="fa fa-trash" />
          </a>
        </template>
      </template>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import BaseServerTable from "@/components/shared/BaseServerTable";
import ExistenceGate from "@/components/shared/ExistenceGate";
import InstrumentJigCollection from "@/collections/lab/InstrumentJigCollection";
import ModalTrashBasket from "@/components/shared/ModalTrashBasket";
import { ServerTable } from "vue-tables-2";
import { mapActions, mapGetters } from "vuex";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { getEntityData } from "@/shared/utils";

Vue.use(ServerTable);

export default {
  name: "InstrumentJigServerTable",
  extends: BaseServerTable,
  components: {
    ExistenceGate,
    ModalTrashBasket,
    ServerTable,
  },
  props: {
    collection: {
      type: Object,
      default: () => new InstrumentJigCollection(),
    },
    show_columns: {
      type: Array,
      default: () => [
        "instrument.name",
        "jig.name",
        "jig.x",
        "jig.y",
        "jig.z",
        "jig.capacity",
        "actions",
      ],
    },
    filterable: {
      type: Array,
      default: () => ["searchable"],
    },
    sortable: {
      type: Array,
      default: () => ["instrument.name", "jig.name"],
    },
  },
  data() {
    const actions_access =
      this.checkPermission("edit instrument jig") ||
      this.checkPermission("delete instrument jig");

    return {
      entity_type: "instrumentJig",
      instrument_id: this.$route.params.instrument_id || null,
      table_config: Object.assign(this.getDefaultTableConfig(actions_access), {
        options: {
          headings: {
            "instrument.name": "Instrument",
            "jig.name": "Jig Name",
            "jig.x": "X",
            "jig.y": "Y",
            "jig.z": "Z",
            "jig.capacity": "Capacity",
            actions: "Actions",
          },
          filterable: this.filterable,
          sortable: this.sortable,
        },
      }),
    };
  },
  computed: {
    ...mapGetters({
      trash: "instrumentJigTrash",
    }),
    show_modal() {
      return (
        this.checkPermission("delete instrument jig") &&
        this.show_columns.includes("actions")
      );
    },
  },
  methods: {
    ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),
    getData({ _reference }, data) {
      return getEntityData({
        entity: _reference,
        ...data,
      });
    },
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    prepareCollectionFilter(filter) {
      this.instrument_id &&
        filter.filterEquals("instrument_id", this.instrument_id);

      return filter;
    },
    putToTrash(value) {
      this.PUT_TO_TRASH({ value, name: this.entity_type });
    },
    restoreFromTrash(id) {
      this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
    },
    isDeleted(id) {
      return this.trash.find((item) => item.id === id);
    },
    onUpdate() {
      this.$refs[this.ref].refresh();
    },
  },
};
</script>
